import React from 'react';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose: () => void;
}

export default class Toast extends React.Component<ToastProps> {
  private timeoutId?: number;

  componentDidMount() {
    // Auto-dismiss after 3 seconds
    this.timeoutId = window.setTimeout(() => {
      this.props.onClose();
    }, 3000);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    const { message, type = 'success', onClose } = this.props;

    return (
      <div className={`toast toast-${type}`}>
        <span>{message}</span>
        <button onClick={onClose} aria-label="Close">×</button>
      </div>
    );
  }
}
